module.exports = __webpack_public_path__ + "img/neb0-starless.57f40867.png";